export default [
  "InvestPlanRestService",
  function (InvestPlanRestService) {
    const currentYear = new Date().getFullYear();
    const localFilter = {
      municipality: null,
      industry: [],
      source: null,
      startYear: {
        id: currentYear,
        nane: currentYear,
      },
      endYear: {
        id: currentYear,
        nane: currentYear,
      },
    };

    function collectFilters() {
      let filters = [
        `'entityStatus' EQ 'ENABLED'`,
        `EXTRA:'milestone' NE '225'`,
      ];

      if (localFilter.municipality && localFilter.municipality.id !== null) {
        filters.push(
          `EXTRA:'placesmunicipality' EQ '${localFilter.municipality.id}'`
        );
      }

      if (Array.isArray(localFilter.industry) && localFilter.industry.length) {
        //Проверка, если выбран пункт меню "Не выбрано"
        if (
          !(
            localFilter.industry.length === 1 &&
            localFilter.industry[0].id === null
          )
        ) {
          filters.push(
            `EXTRA:'industry' EQ '${localFilter.industry
              .map((n) => n.id)
              .join(";")}'`
          );
        }
      }

      if (localFilter.source && localFilter.source.id !== null) {
        filters.push(`EXTRA:'${localFilter.source.id}' EQ 'true'`);
      }

      if (localFilter.startYear && localFilter.startYear.id !== null) {
        filters.push(`'startYear' EQ '${localFilter.startYear.id}'`);
      }

      if (localFilter.endYear && localFilter.endYear.id !== null) {
        filters.push(`'endYear' EQ '${localFilter.endYear.id}'`);
      }

      return filters;
    }

    return {
      api: InvestPlanRestService,
      collectFilters,
      localFilter,
    };
  },
];
